/* tslint:disable */
/* eslint-disable */
/**
 * Roman Swagger
 * Roman - Wire Bots Proxy
 *
 * The version of the OpenAPI document: 1.15.0
 * Contact: dejan@wire.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';

/**
 *
 * @export
 * @interface ServiceInformation
 */
export interface ServiceInformation {
  /**
   *
   * @type {string}
   * @memberof ServiceInformation
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof ServiceInformation
   */
  company?: string;
  /**
   *
   * @type {string}
   * @memberof ServiceInformation
   */
  service?: string;
  /**
   *
   * @type {string}
   * @memberof ServiceInformation
   */
  serviceCode: string;
  /**
   *
   * @type {string}
   * @memberof ServiceInformation
   */
  serviceAuthentication: string;
  /**
   *
   * @type {string}
   * @memberof ServiceInformation
   */
  appKey: string;
  /**
   *
   * @type {string}
   * @memberof ServiceInformation
   */
  webhook?: string;
}

export function ServiceInformationFromJSON(json: any): ServiceInformation {
  return ServiceInformationFromJSONTyped(json, false);
}

export function ServiceInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceInformation {
  if ((json === undefined) || (json === null)) {
    return json;
  }
  return {

    'email': !exists(json, 'email') ? undefined : json['email'],
    'company': !exists(json, 'company') ? undefined : json['company'],
    'service': !exists(json, 'service') ? undefined : json['service'],
    'serviceCode': json['service_code'],
    'serviceAuthentication': json['service_authentication'],
    'appKey': json['app_key'],
    'webhook': !exists(json, 'webhook') ? undefined : json['webhook'],
  };
}

export function ServiceInformationToJSON(value?: ServiceInformation | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {

    'email': value.email,
    'company': value.company,
    'service': value.service,
    'service_code': value.serviceCode,
    'service_authentication': value.serviceAuthentication,
    'app_key': value.appKey,
    'webhook': value.webhook,
  };
}


